<template>
    <div
         class="account-profile-company">
        <div class="account-profile-company__title">{{$tProfile('Employer profile')}}</div>

        <div v-if="pending" class="page__columns-inner container-inner">
          <div class="page__main-col">
            <BasePreloader/>
          </div>
        </div>

        <div v-else-if="!pending && data"
              class="account-profile-company__columns"
              :class="{ _disabled: !isDataChanges && employer.name }">

            <div @click="onChangeData()" class="inline-link change-data-link d-none d-sm-flex">
              <BaseSvg name="ico-edit" class="ico-edit" height="1.4rem" width="1.3rem" />
              <span>{{$tEmployer('Apply for data change')}}</span>
            </div>

            <main class="account-profile-company__main-col">
              <div v-if="typeof data.register !== 'undefined'" class="company-info">
               <RegistrationInfo  v-model="data.register"
                                   @change-data="onChangeData"
                                   @change="onInputsChanges"/>
                <h2 class="company-info__block-title">{{$tEmployer('Additional data')}}</h2>
                <div class="company-info__additional">
                  <EmployerProfileAdditional v-model="data.additional"
                                             @delete-logo="onDeleteLogo()"
                                             @logo-upload="onLogoUpload($event)" />
                  <EmployerProfileMedia :employer="employer" />
                  <EmployerProfileBranches v-model="data.branches"
                                           @change="onInputsChanges"/>
                </div>
              </div>
              <div class="account-profile__footer">
                  <button type="button"
                          @click.prevent="saveData"
                          :disabled="disable"
                          class="company-info__save base-btn  base-btn--blue">
                      <BasePreloader v-if="saveDataPending"/>
                      <BaseSvg name="ico-tick" width="1.4rem" height="1.8rem"/>
                      <span>{{$tEmployer('Save changes')}}</span>
                  </button>
                  <div class="company-info__notify">
                    <template v-if="notify">
                      <BaseAlert
                        class="company-info__notify-inner"
                        :class="'_' + notify.type"
                        :value="notify.text"
                      />
                    </template>
                  </div>
              </div>
            </main>
        </div>
    </div>
</template>

<script>
    import { http } from '../../axios';
    import RegistrationInfo from "../../components/RegistrationInfo";
    import EmployerProfileAdditional from "../../components/EmployerProfileAdditional";
    import EmployerProfileBranches from "../../components/EmployerProfileBranches";
    import EmployerProfileMedia from "../../components/EmployerProfileMedia";
    import formMixins from '../../mixins/formMixins'

    export default {
        mixins: [formMixins],
        components: {
            RegistrationInfo,
            EmployerProfileAdditional,
            EmployerProfileBranches,
            EmployerProfileMedia
        },
        data() {
            return {
              pending: false,
              employer: {},
              data: null,
              notify: null,
              dataTemplate: {
                // Register data
                register: {
                  inputs:{
                    nameCompany: {
                      value: '',
                      error: null,
                      required: true
                    },
                    shortNameCompany: {
                      value: '',
                      error: null,
                      required: true
                    },
                    codeCompany: {
                      value: '',
                        error: null,
                        required: true
                    },
                    country: {
                      value: '',
                        error: null,
                        required: true
                    },
                    region: {
                      value: '',
                        error: null,
                        required: false
                    },
                    district: {
                      value: '',
                        error: null,
                        required: false
                    },
                    locality: {
                      value: '',
                        error: null,
                        required: true
                    },
                    street: {
                      value: '',
                        error: null,
                        required: true
                    },
                    house: {
                      value: '',
                        error: null,
                        required: true
                    },
                    office: {
                      value: '',
                        error: null,
                    },
                    indexCompany: {
                      value: '',
                        error: null,
                        required: true
                    },
                    agentCompany: {
                      value: '',
                        error: null,
                    },
                    phone: {
                      value: '',
                      error: null,
                    },
                    website: {
                      value: '',
                        error: null,
                        required: false
                    },
                    email: {
                      value: '',
                        error: null,
                    }
                  }
                },
                additional: {
                  company_information: null,
                  description: null,
                  logo: '',

                },
                branches: {
                  address: ''
                }
              },
              media: [],
              isDataChanges: false,
              logoFile: null,
              saveDataPending: false,
              disable: true
            }
        },
        computed: {
          user() {
              return this.$store.state.user.profile
          }
        },
        methods: {
          init() {
            this.$set(this, 'data', JSON.parse(JSON.stringify(this.dataTemplate)));
            this.load()
          },
          load() {
            this.pending = true

            return http.get('/api/cabinet/employer-profile/0' ).then(({data}) => {
                if(data.data.id) {
                return this.getEmployer()
              }
            }).catch((error)=>{
              if( error.response.status == 400) {
                return this.postEmployer()
              }
            }).finally(()=>{this.pending = false})
          },
          postEmployer() {
            return http.post('/api/cabinet/employer-profile').then(({data}) => {
              let employer = data.data;
            this.employer = employer;

            if (this.employer !== null) {
              if (employer.name) this.data.register.inputs.nameCompany.value = employer.name;
              if (employer.short_name) this.data.register.inputs.shortNameCompany.value = employer.short_name;
              if (employer.company_code) this.data.register.inputs.codeCompany.value = employer.company_code;
              if (employer.country) this.data.register.inputs.country.value = employer.country;
              if (employer.region) this.data.register.inputs.region.value = employer.region;
              if (employer.locality) this.data.register.inputs.locality.value = employer.locality;
              if (employer.district) this.data.register.inputs.district.value = employer.district;
              if (employer.street) this.data.register.inputs.street.value = employer.street;
              if (employer.build_number) this.data.register.inputs.house.value = employer.build_number;
              if (employer.office) this.data.register.inputs.office.value = employer.office;
              if (employer.index) this.data.register.inputs.indexCompany.value = employer.index;

              // contacts
              if (employer.phone_name) this.data.register.inputs.agentCompany.value = employer.phone_name;
              if (employer.phone) this.data.register.inputs.phone.value = employer.phone;
              if (employer.website) this.data.register.inputs.website.value = employer.website;
              if (employer.email) this.data.register.inputs.email.value = employer.email;

              // additional data
              let company_information = null;
              if (employer.translations) employer.translations.forEach((text) => {
                switch(text.column_name){
              case'company_information':{
                  if (!company_information) company_information = {};
                  company_information[text.locale] = text.value;
                  break;
                }
              }
            })
              if (company_information) this.data.additional.company_information = JSON.stringify(company_information);
              if (employer.fillials) this.data.branches.address = employer.fillials;
              if (employer.company_logo) this.data.additional.logo = employer.company_logo;

              if (employer.gallery) {
                this.media = employer.gallery;
                this.media.sort((a, b) => a.position - b.position
              );
              }
            }
          })
          },
          getEmployer() {
            return http.get('/api/cabinet/employer-profile/0').then(({data}) => {
              let employer = data.data;
              this.employer = employer;

              if(this.employer !== null) {
                if (employer.name) this.data.register.inputs.nameCompany.value = employer.name;
                if (employer.short_name) this.data.register.inputs.shortNameCompany.value = employer.short_name;
                if (employer.company_code) this.data.register.inputs.codeCompany.value = employer.company_code;
                if (employer.country) this.data.register.inputs.country.value = employer.country;
                if (employer.region) this.data.register.inputs.region.value = employer.region;
                if (employer.locality) this.data.register.inputs.locality.value = employer.locality;
                if (employer.district) this.data.register.inputs.district.value = employer.district;
                if (employer.street) this.data.register.inputs.street.value = employer.street;
                if (employer.build_number) this.data.register.inputs.house.value = employer.build_number;
                if (employer.office) this.data.register.inputs.office.value = employer.office;
                if (employer.index) this.data.register.inputs.indexCompany.value = employer.index;

                // contacts
                if (employer.phone_name) this.data.register.inputs.agentCompany.value = employer.phone_name;
                if (employer.phone) this.data.register.inputs.phone.value = employer.phone;
                if (employer.website) this.data.register.inputs.website.value = employer.website;
                if (employer.email) this.data.register.inputs.email.value = employer.email;

                // additional data
                let company_information = null;
                if (employer.translations) employer.translations.forEach((text) => {
                  switch (text.column_name) {
                case 'company_information': {
                    if (!company_information) company_information = {};
                    company_information[ text.locale ] = text.value;
                    break;
                  }
                }
              })
                if (company_information) this.data.additional.company_information = JSON.stringify(company_information);
                if (employer.fillials) this.data.branches.address = employer.fillials;
                if (employer.company_logo) this.data.additional.logo = employer.company_logo;


                if (employer.gallery) {
                  this.media = employer.gallery;
                  this.media.sort((a, b) => a.position - b.position);
                }
              }

            }).finally(()=>{
                this.isDataChanges = false;
                this.pending = false
              })
            },
          onChangeData() {
            this.isDataChanges = true;
          },
          onDeleteLogo() {
            this.data.additional.logo = ''
            this.logoFile = null
          },
          onLogoUpload(e) {
              let files = e.target.files || e.dataTransfer.files
              this.logoFile = files[0]
              if (!files.length)
                return;
              this.createImage(files[0])
          },
          createImage(file) {
            let reader = new FileReader();
            reader.onload = (e) => {
              this.data.additional.logo = e.target.result;
            }
            reader.readAsDataURL(file);
          },
          moveImage({ from, to }) {
            if (from === to) return;

            const arr = this.images.slice(0);
            if (to >= arr.length) {
              let k = to - arr.length + 1;
              while (k--) arr.push(undefined);
            }

            arr.splice(to, 0, arr.splice(from, 1)[ 0 ]);
            this.images = arr;
          },
          saveData() {
            this.resetErrorsMix()

            this.createSendDataMix(this.data.register.inputs)
            if (this.isRequiredEmptyMix) {
              return this.setNotify(this.$tEmployer('Fill required fields'), 'error');
            } else if (!this.emailValid(this.data.register.inputs.email.value)) {
              return this.setNotify(this.$tEmployer('Enter the correct email'), 'error');
            }
            if(!this.isRequiredEmptyMix) {
              this.saveDataPending = true
              try {
                const formData = new FormData();

                if(this.data.register.inputs.nameCompany.value) formData.append('name', this.data.register.inputs.nameCompany.value);
                if(this.data.register.inputs.shortNameCompany.value) formData.append('short_name', this.data.register.inputs.shortNameCompany.value);
                if(this.data.register.inputs.codeCompany.value) formData.append('company_code', this.data.register.inputs.codeCompany.value);

                if(this.data.register.inputs.country.value) formData.append('country', this.data.register.inputs.country.value);
                if(this.data.register.inputs.region.value) formData.append('region', this.data.register.inputs.region.value);
                if(this.data.register.inputs.locality.value) formData.append('locality', this.data.register.inputs.locality.value);
                if(this.data.register.inputs.district.value) formData.append('district', this.data.register.inputs.district.value);
                if(this.data.register.inputs.street.value) formData.append('street', this.data.register.inputs.street.value);
                if(this.data.register.inputs.house.value) formData.append('build_number', this.data.register.inputs.house.value);
                if(this.data.register.inputs.office.value) formData.append('office', this.data.register.inputs.office.value);
                if(this.data.register.inputs.indexCompany.value) formData.append('index', this.data.register.inputs.indexCompany.value);

                if(this.data.register.inputs.agentCompany.value) formData.append('phone_name', this.data.register.inputs.agentCompany.value);
                if(this.data.register.inputs.phone.value) formData.append('phone', this.data.register.inputs.phone.value);
                if(this.data.register.inputs.website.value) formData.append('website', this.data.register.inputs.website.value);
                if(this.emailValid(this.data.register.inputs.email.value)) {
                  formData.append('email', this.data.register.inputs.email.value);
                }
                if (this.data.additional.company_information) {
                  formData.append('company_information', this.data.additional.company_information);
                }
                if (this.logoFile !== null) {
                  formData.append('company_logo', this.logoFile);
                }
                if (this.data.branches.address) {
                  formData.append('fillials', this.data.branches.address);
                }


                return http.post('/api/cabinet/employer-profile', formData).then(()=> {
                  this.setNotify(this.$tEmployer('Successfully saved'), 'success');
                  this.disable = true
                  this.resetErrorsMix(this.data.register.inputs)
                }).finally(()=>{
                    this.getEmployer()
                    this.isDataChanges = false
                    this.saveDataPending = false

                  let form_data = {};
                  formData.forEach((value, key) => {form_data[key] = value});
                  let json = JSON.stringify(form_data)

                  if(json) {
                   // console.log(json)
                    this.$store.dispatch('sendAlert', {
                      type: 'form',
                      title: 'Employer profile data change',
                      params: json
                    })
                  }


                })

              } catch (e) {
                this.setNotify(this.$tAddResume('Error'), 'error');
              }
            }

          },

          setNotify(text, type = 'default') {
            this.notify = { text, type };
            setTimeout(() => this.notify = null, 5000);
          },
          onInputsChanges() {
            if( this.employer.name !== this.data.register.inputs.nameCompany.value ||
                this.employer.short_name !== this.data.register.inputs.shortNameCompany.value ||
                this.employer.company_code !== this.data.register.inputs.codeCompany.value ||
                this.employer.country !== this.data.register.inputs.country.value ||
                this.employer.region !== this.data.register.inputs.region.value ||
                this.employer.locality !== this.data.register.inputs.locality.value ||
                this.employer.district !== this.data.register.inputs.district.value ||
                this.employer.street !== this.data.register.inputs.street.value ||
                this.employer.build_number !== this.data.register.inputs.house.value ||
                this.employer.office !== this.data.register.inputs.office.value ||
                this.employer.index !== this.data.register.inputs.indexCompany.value ||
                this.employer.phone_name !== this.data.register.inputs.agentCompany.value ||
                this.employer.phone !== this.data.register.inputs.phone.value ||
                this.employer.website !== this.data.register.inputs.website.value ||
                this.employer.email !== this.data.register.inputs.email.value ||
                this.employer.company_information !== this.data.additional.company_information ||
                this.employer.fillials !== this.data.data.branches.address
            ) {
              this.disable = false
            } else {
              this.disable = true
            }
          },
          emailValid(email){
            const emailReg = /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/;
            return emailReg.test(email);
          }

        },
        created() {
          for (const key in this.$store.state.locales) {
            if(this.dataTemplate.additional.company_information) {
              this.dataTemplate.additional.company_information[ key ] = '';
            }
          }
        },
        mounted() {
          this.init();
        }

    }
</script>
